import ClockDisplay from './clock_display'
import FeedDisplay from './feed_display'

let pixels = "custom-clock"
let rows = 5
let cols = 4
let params = null

const parseParams = ()=>{
  if(params !== null ){ return params }
  const query = window.location.search.substring(1)
  const vars = query.split('&')
  let out = {}
  for(let k in vars){
    let pair = vars[k].split('=');
    if(pair[0].length > 0){
      out[pair[0]] = pair[1]
    }
  }
  params = out
  return out
}

const displayClock = ()=>{
  const values = {
    pixels,
    rows,
    cols
  }
  document.getElementById('display').innerHTML = ''
  let out = document.createElement('clock-display')
  const params = parseParams()
  console.log(params)
  for(let k in params){
    console.log(k)
    out.setAttribute(k, params[k])
  }

  document.getElementById('display').appendChild(out)
}

const displayFeed = (url)=>{
  let out = document.createElement('feed-display')
  out.setAttribute('src', url)
  document.getElementById('feed').appendChild(out)
}

(()=>{
  displayClock()
  if(parseParams().feed !== undefined){
    displayFeed(parseParams().feed)
  }
})()
